<template>
    <div class="parts">
       <v-header title="新闻列表" :headerLeftStatus="headerLeftStatus" />
       <div class="partsMain">
          <div  class="news">
             <Tabs>
                  <TabPane :label="itemtype.InfoTypeName" v-for="itemtype in newsList" :key="itemtype.InfoType">
                      <div v-for="item in itemtype.NewsList" :key="item.title" class="news_List">
                          <div class="news_title" @click="goNewsDetail(item.OrganizeInfo)">
                              {{item.InfoTitle}}
                          </div>
                          <div class="news_desc">
                              <span>{{item.AuthorName}}</span>
                              <span>{{formatDate(item.PublishTime)}}</span>
                          </div>
                      </div>
                  </TabPane>
              </Tabs>
          </div>
       </div>
       <v-footer></v-footer>
    </div>
</template>

<script>
import header from "@/components/header/index";
import footer from "@/components/footer/index";
//import { GetNewsList } from '@/utils/api'
import { dateFormat } from '@/utils/common'
export default {
  name: 'news',
  data() {
    return {
      headerLeftStatus: true,
      newsList:[],//新闻详细
    };
  },
  mounted() {
    
    this.getNewsList();
    
    
  },
  methods: {
    getNewsList() {
      var param={ClientSign:"News",NewsSize:20};
      GetNewsList(param).then(res=> {
          if(res.Code==1)
          {
             this.newsList=res.Data;
          }
      })
    },
     goNewsDetail(id){
       //通过push进行跳转
      this.$router.push({path:"/newsInfo", query: {Id: id}})
    },
     formatDate(date)
    {
      return dateFormat(new Date(date).getTime(),"yyyy年MM月dd日");
    },
    
  },
   components: {
    "v-header": header,
    "v-footer": footer
  }
}
</script>

<style lang="less" scoped>
.parts {
  position: absolute;
  background: #ffffff;
  width: 100%;
  height: 100%;
  top: 0;
  bottom: 0;
  z-index: 999;
}
.partsHeader {
  width: 100%;
  z-index: 1;
  height: 1.3rem;
  line-height: 1.3rem;
  font-size: 12px;
  background: white;
  position: fixed;
  -webkit-box-shadow: 0 0 10px #cecece;
  box-shadow: 0 0 10px #cecece;
  text-align: center;
  font-size: 0.41rem;
}

.partsHeader i {
  display: block;
  float: left;
  height: 50px;
  padding-left: 0.3rem;
  font-size: 0.71rem;
  color: black;
}
.partsMain {
  margin-top: 1.02rem;
  height: 100%;
}
 .news{
      margin: 10px;
      margin-bottom: 40px;
      
    }
    .news_List{
      height: 1.1rem;
      border-bottom:1px solid #f4f4f4;
    }
    .news_title{
      font-size: 0.30rem;
      margin-top: 10px;
      font-weight:bold;
    }
    .news_desc{
      span{
        margin-right: 10px;
        font-size:12px;
      }
    }
</style>
